import Marionette from "backbone.marionette";
import $ from "jquery";

import tmpl from "../templates/components";
import util from "../util";

export default Marionette.View.extend({
    template: tmpl.Login,
    ui: {
        handle: "#login-handle",
        password: "#login-password",
        error: "#login-error",
    },
    serializeData() {
        return {
            handle: util.getQueryParam("usr"),
        };
    },
    showError(msg) {
        this.ui.error.text(msg);
        this.ui.error.show();
    },
    login() {
        const handle = this.ui.handle.val();
        const password = this.ui.password.val();

        if (!handle.trim().length) {
            this.showError("Please enter your email or phone number");
            return false;
        }

        if (!password.trim().length) {
            this.showError("Please enter your password");
            return false;
        }

        const data = {
            csrf_token: window.csrfToken,
            password,
        };
        this.ui.error.hide();

        if (handle.indexOf("@") > -1) {
            data.email = handle;
        } else {
            data.phone = handle.replace(/\D/g, "");
            if (!data.phone.trim().length) {
                this.showError("Please enter a valid phone number");
                return false;
            }
        }

        const self = this;
        return $.ajax({
            type: "POST",
            url: "/api/hire/v1/auth",
            data: JSON.stringify(data),
            dataType: "json",
            contentType: "application/json",
        }).fail(() => {
            self.showError("Oops! That login didn't work. Please try again");
            setTimeout(() => {
                util.showLoginChat();
            }, 8000);
        });
    },
});
